import { Link } from 'react-router-dom';

function AdminBackButton() {
  return (
    <div className="mb-8">
      <Link
        to="/admin/dashboard"
        className="inline-block bg-gray-600 hover:bg-gray-700 text-white font-bold py-3 px-6 rounded-lg shadow transition"
      >
        ← Terug naar Dashboard
      </Link>
    </div>
  );
}

export default AdminBackButton;